import { apiFetch } from "./config.js";
/** The facts read from documents (admins only). */
export async function listDocumentFacts(params = {}) {
    const q = new URLSearchParams();
    if (params.status)
        q.set("status", params.status);
    if (params.factType)
        q.set("fact_type", params.factType);
    if (params.contract)
        q.set("contract", params.contract);
    if (params.q)
        q.set("q", params.q);
    if (params.limit)
        q.set("limit", String(params.limit));
    const qs = q.toString();
    return apiFetch(`/regulation/facts${qs ? `?${qs}` : ""}`);
}
/** How many facts are in each status: the size of the checking queue. */
export async function documentFactsSummary() {
    return apiFetch("/regulation/facts/summary");
}
/** Agree with a fact, optionally after correcting its text or number. */
export async function confirmDocumentFact(id, edit = {}) {
    return apiFetch(`/regulation/facts/${id}/confirm`, { method: "POST", body: edit });
}
/** Disagree with a fact: it is never offered to the answer writer. */
export async function rejectDocumentFact(id) {
    return apiFetch(`/regulation/facts/${id}/reject`, { method: "POST" });
}
